module.exports = __webpack_public_path__ + "static/media/logo-external.ddb57a5b.png";